import { v5 } from 'uuid'

export const getCloneId = (id: string, initiator: string) => v5(id, initiator)
